import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from '@dr.pogodin/react-helmet';

import Analytics from '../components/Template/Analytics';
import Header from '../components/Template/Header';
import Nav from '../components/Template/Nav';
import ScrollToTop from '../components/Template/ScrollToTop';

const Main = ({ children = null, fullPage = false }) => (
  <>
    <Analytics />
    <ScrollToTop />
    <Helmet
      titleTemplate="%s | Hernan Picatto"
      defaultTitle="Hernan Picatto"
      meta={[{
        name: 'description',
        content: "Hernan Picatto's personal website. Projects, resume, and everything else.",
      }]}
    />
    <div id="wrapper">
      <Header />
      <div id="main">
        {children}
      </div>
      {fullPage ? null : <Nav />}
    </div>
  </>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
};

export default Main;
